import TableFilter from "./TableFilter";
import TableSort from "./TableSort";
import { classNames } from "../../../helpers/classNames";
import Checkbox from "../../form/Checkbox";
import TableSearch from "./TableSearch";

const Th = ({
  name,
  nameAlign,
  isSort,
  isFilter,
  isFilterSearch,
  filterDropdown,
  type,
  onSort = () => { },
  onFilter = () => { },
  filterSearch = () => { },
  handleCheckboxChange,
  onCheckboxChange,
  checkboxChecked,
  totalDataCount,
  isSearchFilter,
  onSearchFilter = () => { },
  keywordSearch = () => { },
  searchData,
  isOption,
  ...props
}) => {
  const align = {
    left: "justify-start",
    right: "justify-end",
    center: "justify-center",
    "": "justify-start",
  };
  return (
    <>
      <th
        className={classNames(
          "py-4 px-2 text-left max-w-[240px] border-none bg-violet-100 first:rounded-tl-md last:rounded-tr-md border-denim first:border-l last:border-r",
          "last:right-0"
        )}>
        <div className={classNames("flex items-center gap-1 w-full", align[nameAlign])}>
          <div className="text-xs uppercase font-semibold text-primaryText whitespace-nowrap">{name}</div>
          {type === "checkbox" && <Checkbox checked={checkboxChecked} onChange={onCheckboxChange} checkboxClass={"w-4 h-4"}/>}
          {(isSort || isFilter || isSearchFilter) && (
            <div className="flex justify-end items-center flex-shrink-0">
              {isSort && <TableSort sortState={"nostate"} onSort={onSort} />}
              {isFilter && (
                <TableFilter
                  xPlacement={"right"}
                  filterData={filterDropdown}
                  isFilterSearch={isFilterSearch}
                  filterSearch={filterSearch}
                  onFilter={onFilter}
                  totalDataCount={totalDataCount}
                />
              )}
              {isSearchFilter && (
                <TableSearch
                  xPlacement={"bottom"}
                  onSearchFilter={onSearchFilter}
                  totalDataCount={totalDataCount}
                  keywordSearch={keywordSearch}
                  searchData={searchData}
                  isOption={isOption}
                />
              )}
            </div>
          )}
        </div>
      </th>
    </>
  );
};

export default Th;
